import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      const el = document.querySelector('.myBody');
      if (el) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    // Run on initial mount AND every pathname change
    scrollToTop();

    // Optional: you can delay it slightly if your content renders slowly
    // setTimeout(scrollToTop, 100);
  }, [pathname]);

  return null;
}
